import React from "react";
import { Checkbox } from "@rmwc/checkbox";
import { Select } from "@rmwc/select";
import { TextField } from "@rmwc/textfield";
import EditPriceItem from "../../EditPriceItem/EditPriceItem.js";
import { connect, useDispatch, useSelector } from "react-redux";
import {
	changeOtherBuildingTypeName,
	trussChange,
	extraItemsAction,
	setBuildingFlags,
	roofStyleChange,
	handleLiftRequired,
	getPricingData,
	changeProductStatus,
	changeBuildingOnCenter,
	hasDoublelegBaiserail
} from "../../../action/index.js";
import { changeBuildingRoof, changeBuildingDimension } from "../../../action/building/building_style/buildingStyle.action.js";
import { gaugeChange } from "../../../action/building_component/buildingComponent.action.js";
import { closeAddGableLeanBuildingModal } from "../../../action/lean_building_pricing/api.actions.getPricingDataForLeanto.js";
import { Radio } from "@rmwc/radio";
import { handleAccordionTab } from "../../../action/building/building_style/buildingStyle.action.js";
import * as validate from "../../Modals/validations.js";
import { const_var } from "../../../redux/reducers/reducer.js";
import ReadMore from "../../ReadMore/index.js";
import { Fragment } from "react";
import CurrencyFormat from "react-currency-format";
import { cloneUniformsGroups } from "three";
import { getRoofPitchLabel } from "../../../utils/Functions.js";
import RoofStyleSetting from "./RoofStyleSetting.jsx";
import GaugeSetting from "./GaugeSetting.jsx";
import RoofPitchSetting from "./RoofPitchSetting.jsx";
import BracingSetting from "./BracingSetting.jsx";
import LegHeightOptions from "./LegHeightOptions.jsx";
import BuildingInfo from "./BuildingInfo.jsx";
import TrussSection from "./TrussSection.jsx";
import InventorySettings from "./InventorySetting.jsx";
import { BuildingDimensions } from "./BuildingDimensions.jsx";

const BuildingSize = () => {
	const { const_var, params, defaultBuilding } = useSelector((state) => state.reducer);
	const dispatch = useDispatch();

	let showEndCrossBracing = false;
	let showEndCrossBracingDisabled = false;

	let showSideCrossBracing = false;
	let showSideCrossBracingDisabled = false;

	let elementPrice = const_var.UpdatedPriceData.length > 0 && const_var.UpdatedPriceData["elements"] != undefined && const_var.UpdatedPriceData["elements"];

	if (const_var.a_p_d_a.side_cross_bracing != undefined && const_var.a_p_d_a.side_cross_bracing.length > 0) {
		if (const_var.a_p_d_a.side_cross_bracing != undefined && const_var.a_p_d_a.side_cross_bracing.length > 0 && const_var.a_p_d_a.side_cross_bracing[0].is_default != "no") {
			showSideCrossBracing = true;
			if (const_var.a_p_d_a.side_cross_bracing[0].is_default == "included") {
				showSideCrossBracingDisabled = true;
			}
		} else {
			showSideCrossBracing = false;
		}
	} else {
		showSideCrossBracing = false;
		showSideCrossBracingDisabled = false;
	}

	if (const_var.a_p_d_a.addons_width && const_var.a_p_d_a.addons_width.length > 0 && const_var.a_p_d_a.addons_width[0].end_cross_bracing != undefined && const_var.a_p_d_a.addons_width[0].end_cross_bracing != 0) {
		showEndCrossBracing = true;
	} else if (const_var.a_p_d_a.end_cross_bracing != undefined && const_var.a_p_d_a.end_cross_bracing.length > 0) {
		if (const_var.a_p_d_a.end_cross_bracing != undefined && const_var.a_p_d_a.end_cross_bracing.length > 0 && const_var.a_p_d_a.end_cross_bracing[0].is_default != "no") {
			showEndCrossBracing = true;
			if (const_var.a_p_d_a.end_cross_bracing[0].is_default == "included") {
				showEndCrossBracingDisabled = true;
			}
		} else {
			showEndCrossBracing = false;
		}
	} else {
		showEndCrossBracing = false;
		showEndCrossBracingDisabled = false;
	}
	const_var.popularSizeArray = [];

	const { buildingWidthArrayCust, buildingLengthArrayCust, DistanceArr, isShowUpdatedBuildingImages, crmSetting } = const_var;
	const { p_w, p_d, p_b_t, p_r_s, isBreezeway } = params;
	let distanceOnCenter = 5;
	if (isBreezeway && DistanceArr.length > 0 && DistanceArr[p_b_t][p_r_s] != undefined) distanceOnCenter = DistanceArr[p_b_t][p_r_s];

	const lengthIncrement = !isBreezeway ? 5 : distanceOnCenter;
	const widthIncrement = !isBreezeway ? 2 : distanceOnCenter;

	let i = p_d && buildingLengthArrayCust.length > 0 ? buildingLengthArrayCust.findIndex((item) => item.value === p_d) : 0;
	let j = p_w && buildingWidthArrayCust.length > 0 ? buildingWidthArrayCust.findIndex((item) => item.value === p_w) : 0;

	if (buildingLengthArrayCust.length > 0 && buildingWidthArrayCust.length > 0) {
		for (i; i < buildingLengthArrayCust.length; i += lengthIncrement) {
			if (buildingWidthArrayCust[j] === undefined || buildingLengthArrayCust[i + lengthIncrement] === undefined || const_var.popularSizeArray.length === 4) break;
			let size = buildingWidthArrayCust[j].value + "x" + buildingLengthArrayCust[i + lengthIncrement].value;
			const_var.popularSizeArray.push(size);
		}

		i = p_d && buildingLengthArrayCust.length > 0 ? buildingLengthArrayCust.findIndex((item) => item.value === p_d) : 0;
		for (j; j < buildingWidthArrayCust.length; j += widthIncrement) {
			if (buildingLengthArrayCust[i] === undefined || buildingWidthArrayCust[j + widthIncrement] === undefined || const_var.popularSizeArray.length === 8) break;
			let size = buildingWidthArrayCust[j + widthIncrement].value + "x" + buildingLengthArrayCust[i].value;
			if (const_var.popularSizeArray.indexOf(size) === -1) {
				const_var.popularSizeArray.push(size);
			}
		}
		if (const_var.popularSizeArray.length < 8) {
			i = p_d && buildingLengthArrayCust.length > 0 ? buildingLengthArrayCust.findIndex((item) => item.value === p_d) : 0;
			for (i; i < buildingLengthArrayCust.length; i += lengthIncrement) {
				if (buildingWidthArrayCust[j] === undefined || buildingLengthArrayCust[i + lengthIncrement] === undefined || const_var.popularSizeArray.length === 8) break;
				let size = buildingWidthArrayCust[j].value + "x" + buildingLengthArrayCust[i + lengthIncrement].value;
				if (const_var.popularSizeArray.indexOf(size) === -1) {
					const_var.popularSizeArray.push(size);
				}
			}
		}
	}
	let imageName = const_var?.defaultBuildingArr?.[const_var.selectedDefaultIndex]?.image_url || "";
	if (defaultBuilding != undefined && const_var.defaultBuildingArr.length > 0) {
		const updatedImagePath =
			crmSetting.main_domain_url == "eaglebuildings.com" || crmSetting.api_token == "Bqxq40K4zojI9VBP630isdq7GqlmZOV4oWhnHC5eanGpV7iOacGP9Gba6D9slWTG"
				? isShowUpdatedBuildingImages.includes(crmSetting.main_domain_url)
					? "updatedBuildingImagesEagle/"
					: ""
				: crmSetting.api_token == "hXJbrd8aOJWlbkBnk0iVWXOoXr5UijVTxadw6Il5euMMkG3zoHUgs1Kir0mzETJ1"
					? "updatedIdealSteelBuilding/"
					: isShowUpdatedBuildingImages.includes(crmSetting.main_domain_url)
						? "updatedBuildingImages/"
						: "";
	}

	const building = const_var?.post_data?.building;
	const trussPrice = building?.truss_price || 0;
	const showPrice = const_var.hide_price_calculation != 1 && !const_var.loginSession && trussPrice !== 0;
	const isCustomBuilding = const_var.defaultBuildingImgName !== "Custom_Buildings";
	const trussList = const_var.a_p_d_a?.truss_name || [];
	const filterData = isCustomBuilding ? trussList.filter((item) => item?.is_show && params.p_w >= item.min_width && params.p_w <= item.max_width) : [];

	let heightOptions = false;
	if (
		const_var.hasDoublelegshow === true ||
		(const_var.a_p_d_a.side != undefined && Object.keys(const_var.a_p_d_a.side).length > 0 && const_var.a_p_d_a.side[0].lift_type != undefined && const_var.a_p_d_a.side[0].lift_type != "") ||
		showEndCrossBracing == true ||
		showSideCrossBracing == true
	) {
		if (const_var.commonBuildingFlag.center.buildingHeight === false && const_var.commonBuildingFlag.center.buildingHeightChk) {
			const_var.commonBuildingFlag.center.buildingHeightChk = false;
		}
		heightOptions = true;
	}
	let doubleLegsLabel = "";

	if (
		const_var.hasDoublelegshow === true &&
		const_var.ConditionArr != undefined &&
		const_var.ConditionArr[params.p_b_t] != undefined &&
		const_var.ConditionArr[params.p_b_t][params.p_r_s] != undefined &&
		const_var.ConditionArr[params.p_b_t][params.p_r_s].CustomArray != undefined &&
		const_var.ConditionArr[params.p_b_t][params.p_r_s].CustomArray.length == 1
	) {
		let legType =
			!const_var.isSingleBaseRail && !const_var.ConditionArr[params.p_b_t][params.p_r_s].CustomArray[0].name.includes("Baserails")
				? const_var.ConditionArr[params.p_b_t][params.p_r_s].CustomArray[0].name + " Baserail "
				: const_var.ConditionArr[params.p_b_t][params.p_r_s].CustomArray[0].name;

		if (params.m_s_n != 122) {
			doubleLegsLabel = legType.includes("Double") || legType.includes("double") ? "Double Legs" : legType;
		} else {
			doubleLegsLabel = legType;
		}
	}
	let isInventoryorNot =
		(const_var.crmSetting.duplicate_module != "inventory" && const_var.crmSetting.is_module_name != "inventory") ||
		(const_var.crmSetting.duplicate_module == "order" && const_var.crmSetting.is_module_name == "inventory") ||
		(const_var.crmSetting.duplicate_module == "quote" && const_var.crmSetting.is_module_name == "inventory");

	let standardTrussLabel = "Standard Truss";
	if (params.m_s_n == 153 && params.p_r_s == 3) {
		standardTrussLabel = "Vertical Truss";
	}

	let engineerPlanMsg = "";
	if (params.m_s_n == 72 && (params.p_s_n == 19 || params.p_s_n == 11)) {
		if (params.p_w >= 32) {
			engineerPlanMsg = "Site specific plans may be required. Please contact your local office for details.";
		}
	}

	const openAddGableLeanBuildingModal = (e) => {
		e.preventDefault();
		e.stopPropagation();
		dispatch(closeAddGableLeanBuildingModal());
	};

	let isShowLiftReq = true;

	return (
		<div>
			<div className="building-elements-sec">
				<div className="building-elements-sec-mid">
					<div className="building-elements-sec-mid-scroll">
						<form className="">
							<div className="section-seprator">
								<div className="card-body-inner">
									<BuildingInfo
										params={params}
										const_var={const_var}
										imageName={imageName}
										changeOtherBuildingTypeName={(e, other) => {
											dispatch(changeOtherBuildingTypeName(e, other));
										}}
										handleAccordionTab={(value, key, flag) => {
											console.log("value,key,flag", value, key, flag);
											dispatch(handleAccordionTab(value, key, flag));
										}}
									/>

									<BuildingDimensions
										params={params}
										const_var={const_var}
										heightOptions={heightOptions}
										isShowLiftReq={isShowLiftReq}
										isInventoryorNot={isInventoryorNot}
										changeBuildingDimension={(payload) => {
											console.log("payload", payload);
											dispatch(changeBuildingDimension(payload));
										}}
										setBuildingFlags={(key, value, exactValue) => {
											dispatch(setBuildingFlags(key, value, exactValue));
										}}
										hasDoublelegBaiserail={(e, buildingType, otherLegs) => {
											dispatch(hasDoublelegBaiserail(e, buildingType, otherLegs));
										}}
										handleLiftRequired={(val) => {
											dispatch(handleLiftRequired(val));
										}}
									/>

									<InventorySettings
										params={params}
										const_var={const_var}
										validate={validate}
										changeProductStatus={(e) => {
											dispatch(changeProductStatus(e));
										}}
										changeBuildingOnCenter={(val, action) => {
											dispatch(changeBuildingOnCenter(val, action));
										}}
										openAddGableLeanBuildingModal={openAddGableLeanBuildingModal}
									/>

									<div className="row flex-nowrap">
										<div className="col-5">
											<RoofStyleSetting />
										</div>

										<div className="col-7">
											<RoofPitchSetting
												const_var={const_var}
												params={params}
												changeBuildingRoof={({ event, value, skipCheck }) =>
													dispatch(
														changeBuildingRoof({
															event,
															value,
															skipCheck
														})
													)
												}
											/>
										</div>
									</div>

									<TrussSection
										isCustomBuilding={isCustomBuilding}
										filterData={filterData}
										params={params}
										const_var={const_var}
										standardTrussLabel={standardTrussLabel}
										trussPrice={trussPrice}
										trussChange={(trussName) => {
											dispatch(trussChange(trussName));
										}}
									/>
									<div className="row">
										<GaugeSetting />
									</div>

									<BracingSetting params={params} const_var={const_var} elementPrice={elementPrice} extraItemsAction={() => dispatch(extraItemsAction())} />
								</div>
								{params.m_s_n == "162" && !isCustomBuilding && ((Number(params.p_w) >= 60 && Number(params.p_w) <= 100) || (Number(params.p_h) >= 20 && Number(params.p_h) <= 24)) && (
									<div className="carport-disclaimer-txt">
										<p>This is not an exact of what the building will look like, please contact your representative for pricing.</p>
									</div>
								)}

								{engineerPlanMsg && <div className="storage-info-sec">{engineerPlanMsg}</div>}

								<div className="read-box d-none">
									<ReadMore>
										Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
										ullamco laboris nisi ut aliquip ex ea commodo consequat.
									</ReadMore>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BuildingSize;
